import Events from '@bleckert/events';

class LogStore extends Events {
	constructor() {
		super();

		this.logMessages = [];
		this.warnings = [];
		this.start = new Date();
	}

	clearLog() {
		this.logMessages = [];
	}

	getLog() {
		return this.logMessages;
	}

	warn(...args) {
		this.warnings.push(args.join(' '));
		this.emit('WARNING', ...args);
	}

	log = (...args) => {
		let lstr = `js[${String(new Date().getTime() - this.start)}]:`;

		for (let i = 0; i < args.length; i += 1) {
			if (typeof args[i] === 'object') {
				lstr += ` ${JSON.stringify(args[i])}`;
			} else {
				lstr += ` ${String(args[i])}`;
			}
		}

		this.logMessages.push(lstr);

		this.emit('INFO', ...args);
	};

	clear() {
		this.logMessages = [];
	}

	get messages() {
		return this.logMessages;
	}
}

const Stores = {};
const FunctionalLogger = (store) => {
	if (!Stores[store]) {
		Stores[store] = new LogStore();
	}

	return Stores[store];
};

export { LogStore, FunctionalLogger, Stores };
